import { z } from 'zod';

export const GroupDtoSchema = z.object({
    id: z.string().describe('The id of the group'),
    name: z.string().describe('The name of the playbook'),
    default: z.boolean().describe('Whether this is the default playbook for the user'),
    assistantSettingsId: z
        .string()
        .describe(
            'The id of the assistant setting that is used for this playbook. Assistant settings are the user defined settings for a playbook.',
        ),
    createdAt: z.date().describe('The date and time the playbook was created'),
});
